// extracted by mini-css-extract-plugin
export default {"info":"tweet-info_info__xmtR0","infoLink":"tweet-info_infoLink__C77Uf","infoIcon":"tweet-info_infoIcon__fLWtV"};